import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, NavLink } from 'react-router-dom';
import { Dashboard } from './components/Dashboard';
import { HelpPage } from './components/HelpPage';
import { DataPage } from './components/DataPage';
import { generateMockData } from './utils/mockData';
export function App() {
  // Generate 48 hours of data (one entry per hour)
  const mockData = generateMockData(48);
  const [currentTimeIndex, setCurrentTimeIndex] = useState(mockData.length - 1);
  return <Router data-id="element-0">
      <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-1">
        <header className="bg-white border-b border-gray-200 shadow-sm" data-id="element-2">
          <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-6" data-id="element-3">
            <div className="flex justify-between h-14 sm:h-16" data-id="element-4">
              <div className="flex items-center" data-id="element-5">
                <div className="flex items-center" data-id="element-6">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2PyGUZ5jux3NruNyXAsS43/LLS_logo_notext_8000px.png" alt="Longhorn Life Sciences Logo" className="h-8 sm:h-10 mr-2" data-id="element-7" />
                  <h1 className="text-lg sm:text-xl font-bold" style={{
                  color: '#000080'
                }} data-id="element-8">
                    AiDetect
                  </h1>
                </div>
              </div>
              <nav className="flex space-x-4 sm:space-x-8" data-id="element-9">
                <NavLink to="/" className={({
                isActive
              }) => `inline-flex items-center px-1 pt-1 border-b-2 text-xs sm:text-sm font-medium ${isActive ? 'border-[#000080] text-gray-900' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'}`} end data-id="element-10">
                  Dashboard
                </NavLink>
                <NavLink to="/data" className={({
                isActive
              }) => `inline-flex items-center px-1 pt-1 border-b-2 text-xs sm:text-sm font-medium ${isActive ? 'border-[#000080] text-gray-900' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'}`} data-id="element-11">
                  Data
                </NavLink>
                <NavLink to="/help" className={({
                isActive
              }) => `inline-flex items-center px-1 pt-1 border-b-2 text-xs sm:text-sm font-medium ${isActive ? 'border-[#000080] text-gray-900' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'}`} data-id="element-12">
                  Help
                </NavLink>
              </nav>
            </div>
          </div>
        </header>
        <main className="flex-1" data-id="element-13">
          <div className="max-w-7xl mx-auto py-4 sm:py-6 px-3 sm:px-4 lg:px-6" data-id="element-14">
            <Routes data-id="element-15">
              <Route path="/" element={<Dashboard data={mockData} currentTimeIndex={currentTimeIndex} setCurrentTimeIndex={setCurrentTimeIndex} data-id="element-17" />} data-id="element-16" />
              <Route path="/data" element={<DataPage data={mockData} currentTimeIndex={currentTimeIndex} setCurrentTimeIndex={setCurrentTimeIndex} data-id="element-19" />} data-id="element-18" />
              <Route path="/help" element={<HelpPage data-id="element-21" />} data-id="element-20" />
            </Routes>
          </div>
        </main>
        <footer className="bg-white border-t border-gray-200" data-id="element-22">
          <div className="max-w-7xl mx-auto py-3 sm:py-4 px-3 sm:px-4 lg:px-6" data-id="element-23">
            <p className="text-xs sm:text-sm text-gray-500 text-center" data-id="element-24">
              © 2026 Longhorn Life Sciences, Inc. All rights reserved.
            </p>
          </div>
        </footer>
      </div>
    </Router>;
}